"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InteriorCapacityDTOSchema = exports.InteriorCapacitySchema = exports.InteriorCapacityBaseSchema = exports.INTERIOR_CAPACITY_SEED_NAMES = void 0;
var zod_1 = require("zod");
var CommonMongoModelFields_1 = require("./lib/CommonMongoModelFields");
var ObjectId_1 = require("./lib/ObjectId");
var RequestSST_1 = require("./RequestSST");
/** Default Interior SST ranks seeded when the collection is empty (legacy const list). */
exports.INTERIOR_CAPACITY_SEED_NAMES = __spreadArray([], RequestSST_1.InteriorSSTCapacities, true);
exports.InteriorCapacityBaseSchema = zod_1.z.object({
    Name: zod_1.z.string().trim().min(1, 'The name is required').max(140, 'The name is too long'),
    Order: zod_1.z.number().int().min(0).default(0),
    isHidden: zod_1.z.boolean().default(false).optional(),
    hiddenAt: zod_1.z.coerce.date().nullable().optional(),
    hiddenBy: zod_1.z.instanceof(ObjectId_1.ObjectId).nullable().optional(),
});
exports.InteriorCapacitySchema = exports.InteriorCapacityBaseSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
exports.InteriorCapacityDTOSchema = exports.InteriorCapacityBaseSchema.extend({
    _id: zod_1.z.string(),
    hiddenBy: zod_1.z.string().nullable().optional(),
});
//# sourceMappingURL=InteriorCapacity.js.map